import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Loader2, CheckCircle, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = params.get("token");
    if (!token) { setState("error"); setMessage("Lien de confirmation invalide."); return; }
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/auth/verify-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });
        const data = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) throw new Error(typeof data?.detail === "string" ? data.detail : "Confirmation impossible.");
        setState("ok"); setMessage(data.message || "Adresse confirmée !");
      } catch (e) {
        if (!cancelled) { setState("error"); setMessage(e.message); }
      }
    })();
    return () => { cancelled = true; };
  }, [params]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ background: "#F9F8F6" }} data-testid="verify-email-page">
      <div className="w-full max-w-sm rounded-2xl bg-white border p-8 text-center" style={{ borderColor: "#E5E5E0" }}>
        <img src="/veyer-ciel-logo.png" alt="Véyèr CIEL" className="h-9 mx-auto mb-6" />

        {state === "loading" && (
          <>
            <Loader2 className="w-8 h-8 animate-spin mx-auto" style={{ color: "#2D6A4F" }} />
            <p className="text-sm mt-4" style={{ color: "#7A7A7A" }}>Confirmation en cours…</p>
          </>
        )}

        {state === "ok" && (
          <>
            <CheckCircle className="w-12 h-12 mx-auto" style={{ color: "#2D6A4F" }} />
            <h1 className="text-lg font-bold mt-4" style={{ color: "#1A1A1A", fontFamily: "Manrope, sans-serif" }}>Adresse confirmée</h1>
            <p className="text-sm mt-2" style={{ color: "#7A7A7A" }}>{message}</p>
            <Button onClick={() => navigate("/")} className="w-full h-10 rounded-full mt-6 text-sm font-semibold text-white" style={{ background: "#2D6A4F" }} data-testid="verify-goto-login">
              Se connecter
            </Button>
          </>
        )}

        {state === "error" && (
          <>
            <XCircle className="w-12 h-12 mx-auto" style={{ color: "#EF4444" }} />
            <h1 className="text-lg font-bold mt-4" style={{ color: "#1A1A1A", fontFamily: "Manrope, sans-serif" }}>Confirmation impossible</h1>
            <p className="text-sm mt-2" style={{ color: "#7A7A7A" }}>{message}</p>
            <Button onClick={() => navigate("/")} variant="outline" className="w-full h-10 rounded-full mt-6 text-sm font-semibold" data-testid="verify-back-login">
              Retour à la connexion
            </Button>
          </>
        )}
      </div>
    </div>
  );
}
